<template>
  <div id="nav" key="{{ currId }}">
    <v-btn @click="getAuth">Click Me!</v-btn>
      
 <!--
        <v-data-table 
    :items="transactionsList"
    hide-default-header
    hide-default-footer
    class="elevation-1"
  ></v-data-table>


 <div>
    <b-table striped hover :items="transactionsList"></b-table>
  </div>


      <v-list-item hidden
                    v-for="(item, i) in  transactionsList"
                    :key="i"
                    inactive="true"
                  >

                  <v-card>

                    <v-card-text>
                      <p>{{item.data.responseVar}}</p>
                        <p>{{item.data.amount}}</p>
                          <p>{{item.data.buyerFirstName}}</p>
                            <p>{{item.data.buyerLastName}}</p>
                              <p>{{item.data.ipAddress}}</p>
                                <p>{{item.data.itemName}}</p>
                                  <p>{{item.data.payerName}}</p>
                                    <p>{{item.data.payerPhoneNumber}}</p>
                                      <p>{{item.data.paymentStatus}}</p>
                                        <p>{{item.data.sellerPhoneNumber}}</p>
                                          <p>{{item.data.time}}</p>
                                            <p>{{item.data.timeStamp}}</p>
                                              <p>{{item.data.transactionCode}}</p>
                                                <p>{{item.data.txRef}}</p>
                                                  <p>{{item.data.responseVar}}</p>
                    </v-card-text>
                  </v-card>

      </v-list-item>

      -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    msg: String
  },
  mounted() {
    //  this.$forceUpdate();
  },
  created() { 
    this.$store.dispatch("getTransactions"); 
   
 
   

     
  },
  computed: {
  
    
    transactionsList(){

      var allPurchases = this.$store.getters.transactionsList;
      var newPurchases = [];

      for(var i=0; i<  allPurchases.length; i++)
      {
      
       var innerData = allPurchases[i].data;
     
       newPurchases.push(innerData);

      }
      return newPurchases;
    },
    

  }, 

  methods: {
    

getAuth() {
this.$store.dispatch("authenticateUserGoogle");
}
  },

  data(){
    return{
      items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          { age: 38, first_name: 'Jami', last_name: 'Carney' }
        ]}
  },
};
/*
- Create navigation menu bar 
- Create a side bar 
- Create body section 
*/
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
      h3 {
        margin: 40px 0 0;
      }
      ul {
        list-style-type: none;
        padding: 0;
      }
      li {
        display: inline-block;
        margin: 0 10px;
      }
      a {
        color: #42b983;
      }
    </style>
  </div>
  </template>



// WEBPACK FOOTER //
// src/components/Cart.vue